// extracted by mini-css-extract-plugin
export var actions = "_2s-0";
export var actionsContainer = "_2s-7";
export var border = "_2s-1";
export var childFullHeight = "_2s-f";
export var collapse = "_2s-2";
export var content = "_2s-a";
export var contentChild = "_2s-e";
export var fullscreen = "_2s-c";
export var hasLeftRadius = "_2s-k";
export var headerContainer = "_2s-3";
export var headerRow = "_2s-5";
export var hidePadding = "_2s-b";
export var navCollapsedGap = "_2s-l";
export var noScrollX = "_2s-m";
export var noScrollY = "_2s-n";
export var noTopPadding = "_2s-i";
export var optOutTopPadding = "_2s-d";
export var pageMain = "_2s-j";
export var pageOuter = "_2s-g";
export var pagePadding = "_2s-8";
export var pageScroll = "_2s-9";
export var profile = "_2s-o";
export var profileContainer = "_2s-p";
export var profileImage = "_2s-q";
export var profileMain = "_2s-r";
export var profileSubtitle = "_2s-t";
export var profileTitle = "_2s-s";
export var showLeftPadding = "_2s-h";
export var tabsPortalSlot = "_2s-6";
export var tabsWrapper = "_2s-4";
export var title = "_2s-u";